import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CarouselComponent.css';
import slide1 from "../Assests/slide/slider1.jpg";
import slide2 from "../Assests/slide/slider2.jpg";
import slide3 from "../Assests/slide/slider3.jpg";

const CarouselComponent = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = [
    {
      id: 1,
      image: slide1,
      title: "Welcome to CSC",
      subtitle: "Excellence in IT and Network Services",
      btn1: { text: "Our Services", link: "/services" },
      btn2: { text: "People", link: "/people" },
      btn3: { text: "Network Provider Policy", link: "/services-network-provider" },
    },
    {
      id: 2,
      image: slide2,
      title: "Computing Services",
      subtitle: "Computer Labs for the IITD Community",
      btn1: { text: "HPC", link: "https://supercomputing.iitd.ac.in" },
      btn2: { text: "Cloud Computing", link: "https://baadal.iitd.ac.in/baadal" }
    },
    {
      id: 3,
      image: slide3,
      title: "Web Services",
      subtitle: "Web Services for the IITD Community",
      btn1: { text: "Web development", link: "/web-development" },
      btn2: { text: "Web Hosting", link: "/web-hosting" }
    }
  ];

  const handleNext = () => {
    setActiveIndex((prevIndex) => 
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) => 
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const ButtonLink = ({ link, children, transition }) => {
    const isExternal = /^https?:\/\//.test(link);
    
    if (isExternal) {
      return (
        <motion.a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="carousel-btn"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={transition}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {children}
        </motion.a>
      );
    }
    
    return (
      <Link to={link}>
        <motion.button
          className="carousel-btn"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={transition}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {children}
        </motion.button>
      </Link>
    );
  };

  const NavigationButton = ({ direction }) => {
    const isNext = direction === 'next';
    const previewIndex = isNext 
      ? (activeIndex + 1) % slides.length 
      : (activeIndex - 1 + slides.length) % slides.length;

    return (
      <div 
        className={`nav-button ${direction}`}
        onClick={isNext ? handleNext : handlePrev}
      >
        <div className="arrow-with-preview">
          <img 
            src={slides[previewIndex].image}
            alt={`${direction} preview`}
            className="preview-image"
          />
          <div className="arrow-overlay">
            {isNext ? '❯' : '❮'}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="carousel-wrapper">
      <Carousel
        activeIndex={activeIndex}
        onSelect={handleSelect}
        controls={false}
        indicators={false}
        interval={5000}
      >
        {slides.map((slide, index) => (
          <Carousel.Item key={slide.id}>
            <img
              className="d-block w-100 carousel-image"
              src={slide.image}
              alt={`Slide ${index + 1}`}
            />
            <Carousel.Caption className="custom-caption">
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeIndex}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.5 }}
                  className="caption-content"
                >
                  <motion.h2
                    className='text-white caption-title'
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                  >
                    {slide.title}
                  </motion.h2>
                  <motion.p
                   className='text-white caption-subtitle'
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                  >
                    {slide.subtitle}
                  </motion.p>
                  <div className="button-container">
                    <ButtonLink 
                      link={slide.btn1.link}
                      transition={{ delay: 0.6, duration: 0.5 }}
                    >
                      {slide.btn1.text}
                    </ButtonLink>
                    {slide.btn2 && (
                      <ButtonLink 
                        link={slide.btn2.link}
                        transition={{ delay: 0.8, duration: 0.5 }}
                      >
                        {slide.btn2.text}
                      </ButtonLink>
                    )}
                    {slide.btn3 && (
                      <ButtonLink 
                        link={slide.btn3.link}
                        transition={{ delay: 1.0, duration: 0.5 }}
                      >
                        {slide.btn3.text}
                      </ButtonLink>
                    )}
                  </div>
                </motion.div>
              </AnimatePresence>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>

      <NavigationButton direction="prev" />
      <NavigationButton direction="next" />

      <div className="indicators">
        {slides.map((_, idx) => (
          <button
            key={idx}
            className={`indicator ${idx === activeIndex ? 'active' : ''}`}
            onClick={() => handleSelect(idx)}
          >
            <img 
              src={slides[idx].image}
              alt={`Indicator ${idx + 1}`}
              className="indicator-image"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default CarouselComponent;